<span *ngIf="control && errors && errors.length > 0" class="error-container" [ngClass]="{'show': (control.invalid && (control.dirty || control.touched))}">
    <ion-label *ngFor="let error of errors" class="input-error" [ngClass]="{'center': centered, 'hide': (!control.errors || !control.errors[error])}">
        {{errornfo?.[error] || null }}
    </ion-label>
</span>